module.exports = __webpack_public_path__ + "static/media/7952716b-1f8d-4d8b-aa12-0c506f0e258f_1.3612926dc5e52a34df20946a1e41e10b.907b53cc.jpeg";